module.exports = __webpack_public_path__ + "media/alert.b84fccdc.mp3";